var exports = {};
export { exports as default };

exports.greenwich = 0.0; // "0dE",
exports.lisbon = -9.131906111111; // "9d07'54.862\"W",
exports.paris = 2.337229166667; // "2d20'14.025\"E",
exports.bogota = -74.080916666667; // "74d04'51.3\"W",
exports.madrid = -3.687938888889; // "3d41'16.58\"W",
exports.rome = 12.452333333333; // "12d27'8.4\"E",
exports.bern = 7.439583333333; // "7d26'22.5\"E",
exports.jakarta = 106.807719444444; // "106d48'27.79\"E",
exports.ferro = -17.666666666667; // "17d40'W",
exports.brussels = 4.367975; // "4d22'4.71\"E",
exports.stockholm = 18.058277777778; // "18d3'29.8\"E",
exports.athens = 23.7163375; // "23d42'58.815\"E",
exports.oslo = 10.722916666667; // "10d43'22.5\"E"
